import { InputAdornment, TextField } from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/core/styles";

const style = {
  color: "white",
  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
};

const styles = (theme) => ({
  cssOutlinedInput: {
    color: "white !important",
    "&$cssFocused $notchedOutline": {
      borderColor: `red !important`,
    },
  },

  helperTextRoot: {
    margin: 4,
    color: "white",
  },

  cssFocused: {},

  notchedOutline: {
    borderWidth: "1px",
    borderColor: "red !important",
  },
});

class TextBox extends React.Component {
  render() {
    const { classes, endAdornment, startAdornment, ...props } = this.props;
    return (
      <TextField
        //variant={this.props.variant}
        fullWidth
        FormHelperTextProps={{ classes: { root: classes.helperTextRoot } }}
        variant="outlined"
        style={style}
        InputProps={{
          endAdornment: endAdornment ? (
            <InputAdornment position="end"> {endAdornment}</InputAdornment>
          ) : (
            ""
          ),

          startAdornment: startAdornment ? startAdornment : "",

          classes: {
            root: classes.cssOutlinedInput,
            focused: classes.cssFocused,
            notchedOutline: classes.notchedOutline,
          },
          style: { color: "white" },
        }}
        InputLabelProps={{
          style: { color: "white", position: "inherit" },
        }}
        label={this.props.label}
        //key={this.props.key}
        value={this.props.value}
        onChange={(e) => this.props.onChange(e.target.value)}
        onKeyDown={(e) => this.props.onKeyDown(e)}
        disabled={this.props.disabled ? true : false}
        //id={this.props.id}
        {...props}
      />
    );
  }
}

export default withStyles(styles)(TextBox);
